import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userRole: 0, // 0: Admin, 1: Common User
    loggedIn: false,
    isTokenExpired: null,
    refreshEvent: {
      event: new Date().getTime()
    },
    isLoading: false,
    notifications: {
      type: "",
      title: "",
      message: "",
      eventTime: new Date()
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
